import React from 'react';
import { squaresInOrder, isDark, isWhite, SOLID, OUTLINE, PIECE_NAMES } from '../chess';

const SQUARES = squaresInOrder();

export function Piece({ piece }) {
  const type = piece.toLowerCase();
  if (isWhite(piece)) {
    return (
      <span className="piece piece-white" aria-hidden="true">
        <span className="piece-fill">{SOLID[type]}</span>
        <span className="piece-line">{OUTLINE[type]}</span>
      </span>
    );
  }
  return (
    <span className="piece piece-black" aria-hidden="true">
      {SOLID[type]}
    </span>
  );
}

// A presentational 8x8 board. Squares become buttons when `isClickable(sq)` is true.
export default function Board({
  position,
  lastMove,
  selected,
  targets = [],
  hovered,
  labels = {},
  isClickable,
  onSquareClick,
  onSquareHover,
  showCoords = true,
  className = '',
  ariaLabel = 'Chess board',
}) {
  return (
    <div className={`board ${className}`} role="group" aria-label={ariaLabel}>
      {SQUARES.map((sq) => {
        const piece = position[sq];
        const clickable = Boolean(onSquareClick && isClickable && isClickable(sq));
        const classes = [
          'sq',
          isDark(sq) ? 'sq-dark' : 'sq-light',
          lastMove && (lastMove.from === sq || lastMove.to === sq) ? 'is-last' : '',
          selected === sq ? 'is-selected' : '',
          hovered === sq ? 'is-hovered' : '',
          targets.includes(sq) ? (piece ? 'is-capture' : 'is-target') : '',
          clickable ? 'is-clickable' : '',
        ]
          .filter(Boolean)
          .join(' ');

        const content = (
          <>
            {showCoords && sq[0] === 'a' && <span className="coord coord-rank">{sq[1]}</span>}
            {showCoords && sq[1] === '1' && <span className="coord coord-file">{sq[0]}</span>}
            {piece && <Piece piece={piece} />}
          </>
        );

        if (!clickable) {
          return (
            <div key={sq} className={classes}>
              {content}
            </div>
          );
        }

        const label =
          labels[sq] || (piece ? `${isWhite(piece) ? 'White' : 'Black'} ${PIECE_NAMES[piece.toLowerCase()]} on ${sq}` : `Square ${sq}`);

        return (
          <button
            key={sq}
            type="button"
            className={classes}
            aria-label={label}
            aria-pressed={selected === sq ? true : undefined}
            onClick={() => onSquareClick(sq)}
            onMouseEnter={onSquareHover ? () => onSquareHover(sq) : undefined}
            onMouseLeave={onSquareHover ? () => onSquareHover(null) : undefined}
            onFocus={onSquareHover ? () => onSquareHover(sq) : undefined}
            onBlur={onSquareHover ? () => onSquareHover(null) : undefined}
          >
            {content}
          </button>
        );
      })}
    </div>
  );
}
